import { useMemo } from "react";
import { Col, Row, Card, CardBody, CardHeader } from "reactstrap";
import TableContainerMin from "../../../../Components/Common/TableContainerMin";
import { useQuery } from "react-query";
import { getUserById } from "../../../Users/services/userApi";
import { Button, Spin } from "antd";
import { Link } from "react-router-dom";
import { getInspections } from "../../../Inspections/services/inspectionApi";
import { formatDate } from "../../../../Components/Common/FormatDate/FormatDate";

const InspectionsDashboard = () => {
  const { isLoading, isError, error, data: inspections,} = useQuery("inspections", getInspections);
  const incidents = inspections?.filter(inspection => inspection.category === "Incident");

  console.log('incidents', incidents)

  const columns = useMemo(() => [
    // {
    //   Header: "Type d'inspection",
    //   accessor: "typeInspection",
    //   filterable: false,
    // },
    {
      Header: "Chauffeur",
      accessor: "userId",
      Cell: ({ row }) => {
        const { userId } = row.original;
        const { data: driver, isLoading: driverLoading } = useQuery(
          ["driver", userId],
          () => getUserById(userId),
          {
            enabled: !!userId,
          }
        );

        if (driverLoading) {
          return <Spin tip="Chargement..." size="small" />;
        }

        if (driver) {
          return <div>{driver.name}</div>;
        }

        return <div>-</div>;
      },
      filterable: false,
    },
    {
      Header: "Véhicule",
      accessor: (row) => row.vehicle?.brand,
      filterable: false,
    },
    { 
      Header: "Date", 
      accessor: "createdAt",
      Cell: ({ value }) => formatDate(value, true),
      filterable: false,        
    },
    {
      Header: "Statut",
      accessor: "status",
      Cell: ({ value }) => (
        <span
          className={`badge bg-${
            value === "Résolues" ? "success" : "danger"
          }-subtle text-${value === "Résolues" ? "success" : "danger"}`}
        >
          {value}
        </span>
      ),
      filterable: false,
    },
  ]);

  return (
    <Row>
      <Col>
        <Card id="contactList">
          <CardHeader
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>Liste des cinq derniers incidents</span>
            <div>
              <Link to="/incidents" style={{ marginRight: "10px"}}>
                <Button className="btn btn-soft-success">Voir tous</Button>
              </Link>
            </div>
          </CardHeader>
          <CardBody className="pt-0">
            <TableContainerMin
              columns={columns}
              data={incidents?.slice(-5) || []}
              customPageSize={5}
              className="custom-header-css"
              divClass="table-responsive table-card mb-3"
              tableClass="align-middle table-nowrap"
              theadClass="table-light"
            />
            {isLoading && (
              <div className="text-center">
                Chargement des inspections 😉, Merci de patienter ... <Spin />
              </div>
            )}
            {isError && (
              <div className="text-center">
                Erreur lors du chargement des données :{" "}
                {error?.message || error} Actualises la page 😉
              </div>
            )}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default InspectionsDashboard;
